import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { AdBlockInterface } from '~/types/AppData/PageBuilder/AdBlockInterface';

export default component$<AdBlockInterface['props']>(({ id }): JSX.Element => {
  return <div id={id} class='flex justify-center items-center min-h-[280px]' />;
});
